class Storage {
  get(key: string) {
    return localStorage.getItem(key)
  }
  set(key: string, value: string) {
    return localStorage.setItem(key, value)
  }
  remove(key: string) {
    return localStorage.removeItem(key)
  }
  getJSON(key: string) {
    return JSON.parse(this.get(key) || 'null')
  }
  setJSON(key: string, value: string) {
    return this.set(key, JSON.stringify(value))
  }
}

export default new Storage()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Storage.ts